export const MILLISECONDS_TO_WAIT = 200;
export const DEFAULT_SPLIT_PERCENT = 0.33;
export const MIN_LEFT_WIDTH_IN_PX = 220;
export const MAX_LEFT_WIDTH_IN_PX = 1300;
